<div class="section-main-card">
  <div class="sequelae-table-wrapper">
    <table class="sequelae-table">
      <thead>
        <tr>
          <th>{{ card.short_term_title }}</th>
          <th>{{ card.long_term_title }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <ul>
              <li *ngFor="let item of card.short_term" [innerHTML]="item | markdown"></li>
            </ul>
          </td>
          <td>
            <ul>
              <li *ngFor="let item of card.long_term" [innerHTML]="item | markdown"></li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
